
import { Component, Inject, Vue } from 'vue-property-decorator';
import { CustomerContext } from '../../auth/CustomerContext';
import { AccessControl } from '../../auth/types';
import { InjectionKey } from '../../injection-keys';
import { LogoSource, TenantConfig } from '../../../tenants/types';

/**
 * Barra superior: título del tenant, logo y "Cerrar Sesión".
 * - Logo `LogoSource.Static`: el asset del tenant (no depende de la ruta).
 * - Logo `LogoSource.FromMe`: `customer_logo` de la aseguradora de la ruta activa (`CustomerContext`): en una ruta
 *   por token, el `/me/` pedido con el token de la URL; en sesión, el `userInfo` de la sesión. Es reactivo: si el
 *   `HomePage` se reutiliza al pasar de una ruta de sesión a una por token, el logo cambia igual.
 * - "Cerrar Sesión" solo si el acceso activo lo soporta (nunca en rutas por token).
 */
@Component
export default class HeaderToolbar extends Vue {
    @Inject(InjectionKey.Tenant) readonly tenant!: TenantConfig;
    @Inject(InjectionKey.Access) readonly access!: AccessControl;
    @Inject(InjectionKey.Customer) readonly customerContext!: CustomerContext;

    get title(): string {
        return this.tenant.branding.title;
    }

    get titleBold(): boolean {
        return this.tenant.branding.titleBold;
    }

    get logoFromMe(): boolean {
        return this.tenant.branding.logo.source === LogoSource.FromMe;
    }

    get customerLogo(): string | null {
        if (!this.logoFromMe) {
            return this.tenant.branding.logo.staticAsset || null;
        }
        const customer = this.customerContext.customer;
        return (customer && customer.customer_logo) || null;
    }

    get customerName(): string {
        if (!this.logoFromMe) {
            return this.tenant.branding.title;
        }
        const customer = this.customerContext.customer;
        return (customer && customer.customer_name) || 'Customer Logo';
    }

    handleLogout() {
        const next = this.access.logout();
        if (next) {
            this.$router.push(next);
        }
    }
}
